<template>
    <div :href="productUrl" class="vertical-product-card">
        <a :href="productUrl" class="product-image" preserve-state>
            <img :src="product.base_image.small" class="img-responsive" :class="{ 'image-placeholder': ! product.base_image }" alt="product-image">
        </a>

        <div class="product-info">
            <a :href="productUrl" class="product-name" preserve-state>
                <h6>{{ product.name }}</h6>
            </a>

            <div class="product-price notranslate" v-html="product.formatted_price"></div>
            <div class="dimensions">
              <span v-if="product.size" v-html="product.size">
              </span>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
